<template>
  <div class="page-account-deposit"
              ref="deposit"
              page_id= "page_deposit_home">
    <el-row>
      <bCardHeader :param="param"
                   :buttons="buttons"></bCardHeader>
    </el-row>
    <el-row :gutter="30"
            class="m-0">
      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
              class="p-0">
        <div class="deposit-channel card-base card-shadow--small">
          <div class="sel-deposit">{{$t('deposit.index.title')}}</div>
          <p>{{$t('deposit.index.tip')}}</p>

          <div class="trade-warming"><img src="../../../assets/images/notice.png"><b>{{$t('deposit.index.sub_title')}}</b></div>

          <!-- <div class="deposit-methos">
            <img src="../../../assets/images/deposit/Online banking transfer.png" alt="">
            <div class="deposit-link">
              <span class="deposit-list-name"><span class="title">ONLINE BANKING TRANSFER</span></span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div> -->
          <div class="deposit-methos">
            <div @click="gotoLink(item.title)"
                 class="deposit-link"
                 v-for="(item,key) in routers"
                 :key="key"
                 :test_id= item.test_id>
              <div class="deposit-icon">
                <img :src="item.img"
                     alt="">
              </div>
              <span class="deposit-list-name"><span class="title">{{$t('deposit.index.'+item.title)}}</span></span>
              <div class="icon-right"><i class="el-icon-arrow-right"></i></div>
            </div>
          </div>
          <!-- <div class="deposit-methos">
            <img src="../../../assets/images/deposit/Online banking transfer.png" alt="">
            <div class="deposit-link">
              <span class="deposit-list-name"><span class="title">ONLINE BANKING TRANSFER</span></span>
              <i class="el-icon-arrow-right"></i>
            </div> -->
        </div>
      </el-col>
      <el-col :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12">
        <bThreeList :params="parentList"
                    style="margin-top:0"
                    @cencelFun="cencelFun"
                    type="deposit"
                    :src='src'
                    :text="$t('deposit.index.noDeposit')"
                    class="m15 mt-20"></bThreeList>
      </el-col>
    </el-row>
    <el-dialog :title="dialogtitle" :visible.sync="showDialog" width="30%" class="warn-dialog" :show-close="false">
      <div class="dialog-info">{{$t('deposit.requirements_deposit')}}</div>
      <div class="dialog-footer">
        <el-button type="primary" @click="showDialog = false">{{$t('common.iknow')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog class="error-dialog"
                  :visible.sync="spdialogOpen"
                  :title="$t('logout.tips')"
                  width="30%">
                  <div>{{$t('common.spInfo')}}</div>
                  <div slot="footer" class="footer-box">
                    <el-button style="width:40%;margin-left:0;" type="primary" @click="spdialogOpen=false">{{$t('common.ok')}}</el-button>
                  </div>
     </el-dialog>
  </div>
</template>

<script>
import img1 from '../../../assets/images/deposit/Online banking transfer.png'
import img2 from '../../../assets/images/deposit/ATM transfer.png'
import img3 from '../../../assets/images/deposit/Counter transfer.png'
import img4 from '../../../assets/images/deposit/Cheque deposit.png'
import img5 from '../../../assets/images/deposit/FPS-e.png'
import img6 from '../../../assets/images/deposit/subAccount.png'
import { mapGetters, mapState } from 'vuex'
import { getDesposiRecords, getEddidBanksList } from '@/api/v2/deposit'
import { queryWithdrawalLimit } from '@/api/v2/fund'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'deposit',
  data () {
    return {
      src: require('@/assets/images/noDeposit.png'),
      text: 'noDeposit',
      buttons: [],
      routers: [
        {
          title: 'fps_deposit',
          link: 'fps-deposit',
          img: img5,
          test_id: 'deposit_fps'
        },
        {
          title: 'online_bank_deposit',
          link: 'online-bank-deposit',
          img: img1,
          test_id: 'deposit_online'
        },
        {
          title: 'atm_transfer_deposit',
          link: 'atm-deposit-deposit',
          img: img2,
          test_id: 'deposit_atm'
        },
        {
          title: 'bank_transfer_deposit',
          link: 'bank-transfer-deposit',
          img: img3,
          test_id: 'deposit_counter'
        },
        {
          title: 'cheque_deposit',
          link: 'cheque-deposit',
          img: img4,
          test_id: 'deposit_cheque'
        }
      ],
      param: {
        title: 'depositTitle',
        links: [{ title: 'home' }, { title: 'depositTitle' }]
      },
      labelPosition: 'top',
      form: {
        name: ''
      },
      langIndexOpt: [
        {
          title: '简体中文',
          value: 'cn'
        },
        {
          title: '繁體中文',
          value: 'hk'
        },
        {
          title: 'English',
          value: 'us'
        }
      ],
      lang: '',
      parentList: [],
      subAccountLength: '',
      showDialog: false,
      dialogtitle: this.$t('logout.tips'),
      spdialogOpen: false
    }
  },
  computed: { ...mapGetters(['getUser', 'valueAccountNumber']),
  ...mapState(['userInfo', 'filterSPTradingAccountList']),
    isOnlySP() {
      // return this.userInfo.isSPAccount === 'Y' && !this.filterSPTradingAccountList.length
      return true
    }
  },
  created () {
    // this.subAccountFun()
  },
  async mounted () {
    // 仅有sp账户
    // if (this.isOnlySP) {
    //   return (this.spdialogOpen = true)
    // }
    await this.queryWithdrawalLimit()
    this.getDepoistRecords()
    // 判断该客户是否成功申请子账户，若有子账户则为其添加子账户存款方式，没有则反之
    // this.$api.getsubAccount({
    //   limit: '',
    //   searchParams: {
    //     accountNumber: this.$getProfile().custom.accountNumber,
    //     status: 'completed',
    //     isLock: true
    //   },
    //   sortKey: 'createdTime',
    //   sortVal: '-1'
    // }).then(result => {
    //   var tempArr = result.data.rows
    //   // var newArr = tempArr.filter(function (obj) {
    //   //   return obj.status === 'completed'
    //   // })
    //   this.subAccountLength = tempArr.length
    //   if (this.subAccountLength !== 0) {
    //     this.routers.unshift({ title: 'sub_account_deposit', link: 'subAccount-deposit', img: img6, test_id: 'deposit_subAccount' })
    //   }
    // })
  },
  methods: {
    async queryWithdrawalLimit() {
      let res = await queryWithdrawalLimit()
      if (res && res.code === 200) {
        let isWithdrawalLimit = res.data && res.data.isForbidWithdrawal
        if (isWithdrawalLimit) {
          this.showDialog = true
        }
      }
    },
    cencelFun (val) {
      console.log('----->', val)
    },
    async getDepoistRecords () {
      // let storage = window.localStorage
      // JSON.parse(storage.user)
      try {
        const result = await getDesposiRecords()
        this.initTreeList(result.data)
      } catch (e) {
        e.msg && this.$message.error(e.msg)
      }
    },
    gotoLink: _.debounce(async function (val) {
      // 仅有sp账户
      // if (this.userInfo.isSPAccount === 'Y' && !this.filterSPTradingAccountList.length) {
      //   return (this.spdialogOpen = true)
      // }
      this.$router.push({
        name: 'deposit-type-tab-1',
        params: { activeName: val }
      })
    }, 500, { leading: true, trailing: false }),
    initTreeList (data) {
      this.parentList = []
      data.forEach(element => {
        let item = {}
        item.status = element.status
        item.orderId = element.orderId
        item.childList = {
          accountNo: element.tradeAccountNumber,
          bankCard: element.bankAccount,
          depositAmout:
            element.remittanceCurrency +
            ' ' +
            this.Util.formatCurrency(element.remittanceAmount)
          // realAmount: element.realAmount ? element.realCurrency +
          //   ' ' +
          //   this.Util.formatCurrency(element.realAmount) : '',
          // exchangeAmount: element.exchangeAmount ? element.exchangeCurrency +
          //   ' ' +
          //   this.Util.formatCurrency(element.exchangeAmount) : '',
          // updatedTime: element.createdDate
        }
        if (element.realAmount) {
          Object.assign(item.childList, { realAmount: element.realAmount ? element.realCurrency +
            ' ' +
            this.Util.formatCurrency(element.realAmount) : '' })
        }
        if (element.exchangeAmount) {
          Object.assign(item.childList, { exchangeAmount: element.exchangeAmount ? element.exchangeCurrency +
            ' ' +
            this.Util.formatCurrency(element.exchangeAmount) : '' })
        }
        if (element.depositType === 'BANK_SECURITIES_TRANSFER') {
          Object.assign(item.childList, { depositWay: this.$t('common.yztransfer') })
        }
        if (element.createdDate) {
          Object.assign(item.childList, { applyTime: moment(element.createdDate).format('YYYY-MM-DD HH:mm:ss')
          })
        }
        if (item.status === 'FAILURE') {
          Object.assign(item.childList, { remark: element.remark })
        }
        this.parentList.push(item)
      })
      this.parentList = this.parentList.slice(0, 3)
    },
    // 判断是否有子账户
    async subAccountFun () {
      try {
        let params = {
          depositType: 'SUB_ACCOUNT_DEPOSIT',
          type: ''
        }
        let res = await getEddidBanksList(params)
        // console.log(res.data, 'res')
        // 子账户存vuex
        this.$store.dispatch('setSubBankAccounts', res.data || [])
        this.subAccountLength = res.data && res.data.length
        if (this.subAccountLength !== 0 && this.userInfo.type !== 'COMPANY') {
          this.routers.unshift({ title: 'sub_account_deposit', link: 'subAccount-deposit', img: img6, test_id: 'deposit_subAccount' })
        }
      } catch (e) {
        this.$message.error(e)
      }
    }
  }
}
</script>
<style lang="scss">
.page-account-deposit {
  height: min-content;
  .error-dialog{
    .footer-box{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .el-dialog__header{
      text-align: center;
      font-weight: 600;
    }
  }
  .warn-dialog {
    .dialog-info {
      font-size: 14px;
      font-weight: 400;
      color: #7d7d7d;
      line-height: 21px;
      &:first-of-type {
      margin-bottom: 15px;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: center;
      padding-top: 30px;
      .el-button {
        padding: 18px 96px;
        background: #fec000;
        border-radius: 5px;
        color: #192b57;
        font-size: 14px;
      }
    }
  }
}
.deposit-channel {
  background-color: #fff;
  padding: 20px 28px 57px;
  .sel-deposit {
    font-family: Muli-Bold;
    font-size: 18px;
    color: #182a54;
    letter-spacing: 0.22px;
    margin-bottom: 20px;
    font-weight: 600;
  }

  .trade-warming {
    background: rgba(254, 192, 0, 0.2);
    height: 50px;
    padding-left: 20px;
    img {
      vertical-align: middle;
    }
  }

  .trade-warming b {
    font-family: Muli-Bold;
    font-size: 14px;
    color: #192b57;
    letter-spacing: 0;
    line-height: 50px;
    // vertical-align: middle;
    padding-left: 20px;
  }

  .deposit-methos {
    clear: none;
    display: block;
    width: 100%;

    .deposit-link {
      display: block;
      margin-top: 20px;
      position: relative;
      float: left;
      width: 100%;
      height: 106px;
      border: 2px solid #fec000;
      border-radius: 5px;
      cursor: pointer;
      // background-color: #192c57;

      .deposit-icon {
        width: 28%;
        // display: table-cell;
        vertical-align: middle;
        text-align: center;
        box-sizing: border-box;
        background-color: #192c57;
        border-radius: 1px;
        float: left;
      }
      .deposit-icon img {
        padding: 20px 0;
      }
      .deposit-list-name {
        width: 60%;
        float: left;
        position: absolute;
        top: 50%;
        transform: transLateY(-50%);

        .title {
          padding-left: 20px;
          color: #192b57;
          font-weight: bold;
          font-size: 1.5em;
          float: left;
        }
      }

      .icon-right {
        float: left;
        position: absolute;
        top: 50%;
        transform: transLateY(-50%);
        right: 0;
        i {
          padding-right: 10px;
          font-size: 24px;
          color: #fec000;
          font-weight: bold;
        }
      }
    }
  }

  .deposit-list-name {
    display: inline-block;
  }
  .h-591 {
    height: 591px;
  }
}

@media (max-width: 991px) {
  .records-list {
    margin-top: 30px !important;
  }
}
@media (max-width: 768px) {
  .layout-container .container .view {
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
  .m-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .p-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .m15 {
    margin-left: -15px;
    margin-right: -15px;
  }
  .mt-20 {
    margin-top: 20px !important;
  }
  .h-100 {
    height: 100%;
  }

}

</style>
